<template>
  <div class="cost-container">
    <div class="flexcon">
      <!-- v-for="(item, index) in data" :key="index" -->
      <div class="cost-legend">
        <div class="item" v-for="(item, index) in legendData" :key="index">
          <div class="icon" :style="{ backgroundColor: color[index] }"></div>
          <div class="name">{{ item.name }}</div>
          <div class="percentage">{{ ((item.price / total) * 100).toFixed(2) }}% |</div>
          <div class="price">¥{{ item.price }}</div>
        </div>
      </div>
    </div>
    <div id="cost-chart" class="cost-chart"></div>
  </div>
</template>
<script>
import Chart from "@/components/charts";
import { onMounted, ref, onUnmounted } from "vue";
export default {
  name: "cost-chart",
  props: {
    data: Object
  },
  setup() {
    const color = [
      "#7983F5",
      "#80DECF",
      "#FDBE71",
      "#F56C68",
      "#3A3DC9",
      "#43B4A8",
      "#079D32",
      "#D06A16",
      "#C92D33",
      "#949FF7",
      "#98E6D7"
    ];
    const chartData = {
      dimensions: ["product", "count"],
      source: {
        product: ["ABAS2022", "智慧办公一体机", "环境与健康管理", "招商云", "高效机房", "Edge Box"],
        count: [200000, 65000, 50000, 30000, 20000, 1200]
      }
    };
    const echart = ref({});
    let total = chartData.source.count.reduce((x, y) => {
      return x + y;
    });
    const legendData = [
      {
        name: "ABAS2022",
        price: 200000
      },
      {
        name: "智慧办公一体机",
        price: 65000
      },
      {
        name: "环境与健康管理",
        price: 50000
      },
      {
        name: "招商云",
        price: 30000
      },
      {
        name: "高效机房",
        price: 20000
      },
      {
        name: "Edge Box",
        price: 1200
      },
      // {
      //   name: "智慧办公",
      //   price: 0
      // },
      {
        name: "云启",
        price: 0
      },
      {
        name: "碳中和平台",
        price: 0
      },
      {
        name: "节能管家",
        price: 0
      },
      {
        name: "企业碳管平台",
        price: 0
      }
    ];
    onMounted(() => {
      echart.value = Chart.setPieCost(chartData, color, total, "cost-chart");
    });

    onUnmounted(() => {
      echart.value.remove();
    });
    return {
      total,
      color,
      legendData
    };
  }
};
</script>
<style lang="less">
.cost-container {
  display: flex;
  .cost-chart {
    width: 40%;
    height: 292px;
    margin-top: -28px;
  }
  .flexcon {
    display: flex;
    justify-content: center;
    width: 60%;
    margin-top: 32px;
    .cost-legend {
      display: flex;
      flex-wrap: wrap;
    }
    .item {
      display: flex;
      align-items: center;
      width: 50%;
      height: 40px;
      .icon {
        width: 8px;
        height: 8px;
        margin-right: 6px;
        border-radius: 50%;
      }
      .name {
        width: 124px;
        color: #435969;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }
      .percentage {
        width: 46px;
        color: #4e5969;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        text-align: right;
      }
      .price {
        margin-left: 18px;
        color: #1d2129;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
}
.card-top-more {
  padding-right: 16px;
  color: #86909c;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  background: url(../../../assets/svg/source-arrow.svg) no-repeat right center;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.card-top-more:hover {
  color: #5e66f2;
  background: url(../../../assets/svg/source-arrows.svg) no-repeat right center;
}
</style>
